import React from "react";
import { CareerItem } from "@/types/careerType";
import { truncateText } from "@/utils/text";

interface CareerCardProps {
  career: CareerItem;
  onClick?: (career: CareerItem) => void;
}

/**
 * CareerCard Component
 * Displays an individual career/job listing card
 */
const CareerCard: React.FC<CareerCardProps> = ({ career, onClick }) => {
  // Format date for display
  const formatDate = (dateString?: string) => {
    if (!dateString) return null;
    try {
      return new Date(dateString).toLocaleDateString("vi-VN");
    } catch {
      return dateString;
    }
  };

  return (
    <div
      className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 overflow-hidden cursor-pointer flex flex-col h-full"
      onClick={() => onClick?.(career)}
    >
      {/* Optional image */}
      {career.img && (
        <div className="h-32 bg-gradient-to-r from-green-400 to-blue-500 relative">
          <img
            src={career.img.url}
            alt={career.img.alt || career.title}
            className="w-full h-full object-cover"
          />
        </div>
      )}

      {/* Card content */}
      <div className="p-6 flex-1 flex flex-col">
        {/* Career title and category */}
        <div className="mb-3">
          <h3 className="text-lg font-semibold text-gray-900 mb-1">
            {career.title}
          </h3>
          {career.category && (
            <p className="text-sm font-medium text-green-600">
              {career.category.name}
            </p>
          )}
        </div>

        {/* Career dates */}
        <div className="mb-4 text-xs text-gray-600">
          <div className="flex justify-between">
            <span>Bắt đầu: {formatDate(career.startDate)}</span>
            <span>Kết thúc: {formatDate(career.endDate)}</span>
          </div>
        </div>

        {/* Footer with apply button */}
        <div className="flex items-center justify-end mt-auto">
          <button
            className="bg-green-600 hover:bg-green-700 text-white text-sm font-medium px-4 py-2 rounded-lg transition-colors duration-200 cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              onClick?.(career);
            }}
          >
            Xem chi tiết
          </button>
        </div>
      </div>
    </div>
  );
};

export default CareerCard;
